/**
 * Mappings for keys for which the semantic meaning changes dependening on locale.
 */
/*
const RTL_MAPPINGS = {
  'Left': 'Right',
  'Right': 'Left'
};
*/

const INPUT_ELEMENT_TAG_NAMES = {
  INPUT: true,
  TEXTAREA: true
};

const BUTTON_ELEMENT_TAG_NAMES = {
  A: true,
  BUTTON: true
};

export function isInputElement(eventTarget: EventTarget): boolean {
  let element = <HTMLElement>eventTarget;
  let isInput = element && ((element.tagName in INPUT_ELEMENT_TAG_NAMES) || element.isContentEditable);
  return isInput;
}

export function isButtonElement(eventTarget: EventTarget): boolean {
  let element = <HTMLElement>eventTarget;
  let isButton = element && (element.tagName in BUTTON_ELEMENT_TAG_NAMES);
  return isButton;
}

/**
 * Gets the name of the key which was pressed in a keyboard event.
 * Key names come from the documentation at
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
 * It is essential that all key name values come from the documented list.
 * This ensures that usage of the binding remains consistent.
 */
export function getKeyPressed(event: KeyboardEvent): string {
  'use strict';
  let keyPressed: string;

  keyPressed = getKeyPressedFromCode(event.keyCode);

  if (event.metaKey) {
    keyPressed = 'Meta' + keyPressed;
  }

  if (event.ctrlKey) {
    keyPressed = 'Ctrl' + keyPressed;
  }

  if (event.altKey) {
    keyPressed = 'Alt' + keyPressed;
  }

  if (event.shiftKey) {
    keyPressed = 'Shift' + keyPressed;
  }

  return keyPressed;
}

/**
* Gets a key name from a legacy key code value.
*/
export function getKeyPressedFromCode(keyCode: number): string {
  'use strict';

  let keyPressed: string;

  if (keyCode >= 65 && keyCode <= 91) {
    keyPressed = String.fromCharCode(keyCode);
  } else {
    switch (keyCode) {
      case 8:
        keyPressed = 'Backspace';
        break;
      case 9:
        keyPressed = 'Tab';
        break;
      case 13:
        keyPressed = 'Enter';
        break;
      case 27:
        keyPressed = 'Esc';
        break;
      case 32:
        keyPressed = 'Space';
        break;
      case 37:
        keyPressed = 'Left';
        break;
      case 38:
        keyPressed = 'Up';
        break;
      case 39:
        keyPressed = 'Right';
        break;
      case 40:
        keyPressed = 'Down';
        break;
      case 46:
        keyPressed = 'Delete';
        break;
      case 113:
        keyPressed = 'F2';
        break;
      case 191:
        keyPressed = '/';
        break;
      case 121:
        keyPressed = 'F10';
        break;
      default:
        keyPressed = '';
        break;
    }
  }

  return keyPressed;
}